// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"32b476ee","455":"c85a5dea"}[chunkId] + ".chunk.js";
};